import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

import config from '@/config';
// eslint-disable-next-line import/no-cycle
import { COLLATERAL_DECIMALS } from '@/store/use-markets-store';
import { WsMsg } from '@/types';
import { BigDecimal, bigIntToDecimalStr } from '@/utils/value-format';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const parseWsMsg = async (event: MessageEvent<any>): Promise<WsMsg> => {
  try {
    let text: string;

    if (typeof event.data === 'string') {
      text = event.data;
    } else if (event.data instanceof Blob) {
      const arrayBuffer = await event.data.arrayBuffer();
      text = new TextDecoder().decode(arrayBuffer);
    } else {
      text = String(event.data);
    }

    return JSON.parse(text);
  } catch (e) {
    throw new Error(
      `WebSocket received message format error:\n${e}\nMessage: ${event.data}`,
    );
  }
};

export const logConsole = (isError: boolean, ...params: any[]): void => {
  const { isLocal, isDevelopment } = config;
  if (!isLocal && !isDevelopment) return;
  isError ? console.error(...params) : console.log(...params);
};

export function uint8ArrayToHex(uint8Array: Uint8Array): string {
  return Array.from(uint8Array)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export const getDefaultBigDecimal = (
  decimals: number | bigint = COLLATERAL_DECIMALS,
): BigDecimal => {
  return {
    bigint: 0n,
    decimal: bigIntToDecimalStr(0n, decimals),
  };
};
